import { error } from "console";
import { PoolModelData, CreatePool } from "../model/approvalPoolModel";
import { JobApprovalPoolAction } from "./appprovalPool.action";

export interface ApprovalPoolState {
  poolFormData: Partial<CreatePool>;
  Pools: PoolModelData[];
  total: number;
  users: any[];
  loading: boolean;
  error: string | null;
  showModal: boolean;

  listLoading: boolean;
  deleteDialogOpen: boolean;
  deletingFlowId: string | null;
  editingPool?: PoolModelData | null;
  isPoolDialogOpen?: boolean;
  toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
  poolMode: "create" | "edit" | "view";
}
export const initialState: ApprovalPoolState = {
  poolFormData: { name: "", description: "", members: [] },
  Pools: [] as PoolModelData[],
  total: 0,
  users: [],
  loading: false,
  error: null,
  showModal: false,
  listLoading: false,
  deleteDialogOpen: false,
  deletingFlowId: null,
  editingPool: null,
  isPoolDialogOpen: false,
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
  poolMode: "create",
};

export const ApprovalFlowReducer = (
  state: ApprovalPoolState,
  action: JobApprovalPoolAction,
): ApprovalPoolState => {
  switch (action.type) {
    case "SET_POOL_FORM_DATA":
      return {
        ...state,
        poolFormData: { ...state.poolFormData, ...action.payload },
      };
    case "SET_POOLS":
      return { ...state, Pools: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "SET_USERS":
      return { ...state, users: action.payload };
    case "UPDATE_POOL_FORM_FIELD":
      return {
        ...state,
        poolFormData: {
          ...state.poolFormData,
          [action.payload.field]: action.payload.value,
        },
      };
    case "SET_EDITING_POOL":
      return { ...state, editingPool: action.payload };
    case "RESET_POOL_FORM":
      return {
        ...state,
        editingPool: undefined,
        poolFormData: {
          name: "",
          description: "",
          members: [],
        },
      };
    case "SET_POOL_MODE":
      return {
        ...state,
        poolMode: action.payload,
      };
    case "SET_POOL_DIALOG_OPEN":
      return { ...state, isPoolDialogOpen: action.payload };
    case "CLOSE_POOL_DIALOG":
      return {
        ...state,
        isPoolDialogOpen: false,
        editingPool: null,
      };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "OPEN_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: true,
        deletingFlowId: action.payload,
      };

    case "CLOSE_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: false,
        deletingFlowId: null,
      };
    case "SET_TOAST":
      return { ...state, toast: action.payload };
    case "SET_LIST_LOADING":
      return { ...state, listLoading: action.payload };
    case "HIDE_TOAST":
      return { ...state, toast: { ...state.toast, isVisible: false } };
    default:
      return state;
  }
};
